import React, {useState} from 'react';
import s from '../../ListOfBonuses.module.css';
import {ErrorMessage, Field, Form, Formik} from 'formik';
import {CustomInput} from '../../../../Components/Input';
import {useTranslation} from 'react-i18next';
import {RequestPaymentCreateType} from '../../../../types/TypesUserOrders';
import {useCreatePaymentMutation} from '../../../../redux/DepotSlice/depotCashierApi';
import {toast} from 'react-toastify';
import {useSelector} from 'react-redux';

import {UserClient} from '../../../../types/TypesUser';
import {RootState} from '../../../../redux/store';
import FindDistributorsComponent from '../../../../Components/FindDistributorsComponent/FindDistributorsComponent';
import LightGreenButton from '../../../../Components/Buttons/LightGreenButton';
import * as Yup from 'yup';

const CreateCheckForm: React.FC = () => {
	const {t} = useTranslation();
	const [client, setClient] = useState<UserClient | null>(null);
	const [createOrder] = useCreatePaymentMutation();
	const user = useSelector((state: RootState) => state.userData.userView);

	const initialValues: RequestPaymentCreateType = {
		client_id: client?.client_id || '',
		money: '',
	};
	const handleSubmit = async (values: RequestPaymentCreateType) => {
		try {
			const response = await createOrder(values);
			if (response?.data?.approve) {
				toast.success(response.data.message.textmsg || t('Успішно'));
				// Очищаем данные клиента после успешного сохранения
				setClient(null);
			} else {
				toast.error(response?.data?.message.textmsg || t('Помилка'));
			}
		} catch (e: any) {
			toast.error(e.response.data.message.textmsg);
		}
	};
	const validationMoneySchema = Yup.object({
		money: Yup.number()
			.required('Введіть суму')
			.max(
				Number(client?.money ?? 0),
				`Сума повинна бути не більше ${client?.money ?? 0}`,
			),
	});
	return (
		<Formik
			enableReinitialize
			initialValues={initialValues}
			onSubmit={handleSubmit}
			validationSchema={validationMoneySchema}
		>
			{() => (
				<Form>
					<div className={s.createPaymentContainer}>
						<div className={s.title}>{t('Створити витратний ордер')}</div>
						<div className={s.topBlock}>
							<div className={s.warehouse}>
								{t('Склад')}:{' '}
								<span>
									{user?.name} ({user?.contract})
								</span>
							</div>
							<div className={s.distributor}>
								<div className={s.distributorTitle}>{t("Партнер")}</div>
								<FindDistributorsComponent
									client={client}
									setClient={setClient}
								/>
							</div>
						</div>
						{client?.money && +client.money > 0 && (
							<div className={s.bottomBlock}>
                                <div className={s.takeOf}>
                                    {t('Зняти')} <CustomInput name={'money'} placeholder={t('Сума')} /> грн
                                </div>
								<ErrorMessage
									name="money"
									component="div"
									className={s.error}
								/>
								<div className={s.greenButtonWrapper}>
									<LightGreenButton
										text={t('Зберегти витратний ордер')}
										type={'submit'}
									/>
								</div>
							</div>
						)}
					</div>
				</Form>
			)}
		</Formik>
	);
};

export default CreateCheckForm;
